var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetsuite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 32",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 24,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#125580"
  }, "\r\n    NetSuite\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetsuite);
export default __webpack_public_path__ + "static/media/netsuite.ad050b4552937e98db36ec062debfa1a.svg";
export { ForwardRef as ReactComponent };